// @ts-nocheck
import { set } from './deep-find'
import get from './get'

export const dataCleanser = (keyPaths, data) =>
  data.map((hit) => {
    let result = {}
    keyPaths.reduce((acc, path) => {
      path = path.split('.')
      const val = get(hit, path)
      if (val !== undefined) {
        set(acc, path, val)
      }
      result = {
        ...acc,
      }
      return acc
    }, {})
    return result
  })
